//Components
import MainNavBar2 from "../../components/Main_Interface/MainNavBar/MainNavBar2";
import ProductListCategory2 from "../../components/Main_Interface/Category/ProductListCategory2";
import ProductList2 from "../../components/Main_Interface/Cards/ProductList2";
import MainFooter from "../../components/Main_Interface/Footer/Footer";
import MainFloatingButton from "../../components/Main_Interface/Footer/MainFloatingButton";
import Loader from "../../components/CMS/Loader/Loader";
import ReactPaginate from 'react-paginate';

import React, { useState, useEffect } from "react";
import {useSearchParams} from 'react-router-dom';

export default function ProductList() {
    const [datax, setData] = useState([]);
    const [searchedData, setSearchedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [currentPageValue, setCurrentPageValue] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [endOffset, setOffset] = useState(21);
    const [pageCount, setPageCount] = useState(0);
    const currentItems = searchedData.slice(itemOffset, endOffset);
    const [searchParams, setSearchParams] = useSearchParams();

    const queryParams = new URLSearchParams(window.location.search);
    const style = queryParams.get('style');
    const bulidType = queryParams.get('type');
    
    useEffect(() => {
        if (localStorage.getItem("form_project_detail") == "true") {
            localStorage.setItem("form_project_detail", false);
            getListOnly();
        } else {
            getProjectList();
        }
    }, []);

    const isDataSelected = (project, selectedItems, itemKey) => {
        return !selectedItems.length || selectedItems.includes(project[itemKey]);
    };


    function updateResult(returnObject) {
        setResult(returnObject);
        setSearchedData(datax);

        console.log(returnObject);
        var filteredResult = datax.filter((project) => {
            return (
                isDataSelected(project, returnObject['projectBuildingStyle'], "projectBuildingStyle") &&
                isDataSelected(project, returnObject['projectBuildingType'], "projectBuildingType") &&
                isDataSelected(project, returnObject['hasFeatured'], "hasFeatured")
            );
        });
        setSearchedData(filteredResult);

        if ( returnObject['projectBuildingStyle'].length == 0 && returnObject['projectBuildingType'].length == 0 && returnObject['hasFeatured'] == 0 && returnObject['projectHouseName'] == null) {
            var filteredResult = datax;
            setSearchedData(datax);
        }

        if(style != null){
            searchParams.delete('style');
            setSearchParams(searchParams);
        }

        if(bulidType != null){
            searchParams.delete('bulidType');
            setSearchParams(searchParams);
        }

        setPageLoading(true);
        setPageCount(Math.ceil(filteredResult.length / 21));
        setItemOffset(0);
        setOffset(21);
        setPageLoading(false);
        setCurrentPageValue(0);
        setResult(null);

        localStorage.setItem("pageCount", Math.ceil(filteredResult.length / 21));
        localStorage.setItem("pageValue", 0);
        localStorage.setItem("offset", 21);
        localStorage.setItem("ItemOffset", 0);

        localStorage.setItem("projectBuildingStyle", returnObject['projectBuildingStyle']);
        localStorage.setItem("projectBuildingType", returnObject['projectBuildingType']);
        localStorage.setItem("hasFeatured", returnObject['hasFeatured']);
        localStorage.setItem("projectHouseName", returnObject['projectHouseName']);
    }

    function getProjectList() {
        var apiLink = process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects';
        fetch(apiLink)
            .then(response => response.json())
            .then((usefulData) => {
                setLoading(false);
                setData(usefulData.data.projectList);
                if(bulidType !== null){
                    var filteredResult = usefulData.data.projectList.filter(project => project.projectBuildingType == bulidType);
                    setPageCount(Math.ceil(filteredResult.length / 21));
                    setSearchedData(filteredResult);
                }else if (style !== null) {
                    var filteredResult = usefulData.data.projectList.filter(project => project.projectBuildingStyle == style);
                    setPageCount(Math.ceil(filteredResult.length / 21));
                    setSearchedData(filteredResult);
                } else {
                    setPageCount(Math.ceil(usefulData.data.totalProjectCount / 21));
                    setSearchedData(usefulData.data.projectList);
                }
                localStorage.setItem("pageCount", Math.ceil(usefulData.data.totalProjectCount / 21));
            })
            .catch((e) => {
                console.error(`An error occurred: ${e}`)
            });

        localStorage.setItem("pageValue", currentPageValue);
        localStorage.setItem("offset", endOffset);
        localStorage.setItem("ItemOffset", itemOffset);
    }


    function getListOnly() {
        var apiLink = process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects';
        fetch(apiLink)
            .then(response => response.json())
            .then((usefulData) => {
                setLoading(false);
                setData(usefulData.data.projectList);
                setSearchedData(usefulData.data.projectList);

                var searchProjectBuildingStyle = localStorage.getItem("projectBuildingStyle") == '' || localStorage.getItem("projectBuildingStyle") == null ? []: localStorage.getItem("projectBuildingStyle").split(',');
                var searchProjectBuildingType = localStorage.getItem("projectBuildingType") == '' || localStorage.getItem("projectBuildingType") == null? []: localStorage.getItem("projectBuildingType").split(',');
                var searchHasFeatured = localStorage.getItem("hasFeatured") == '' || localStorage.getItem("hasFeatured") == null? [] : localStorage.getItem("hasFeatured").split(',').map(Number);
                var projectHouseName = localStorage.getItem("projectHouseName");


                if(style != null){
                    searchProjectBuildingStyle.push(style);
                    localStorage.setItem("projectBuildingStyle", searchProjectBuildingStyle);
                }

                var filteredResult = usefulData.data.projectList.filter((project) => {
                    return (
                        isDataSelected(project, searchProjectBuildingStyle, "projectBuildingStyle") &&
                        isDataSelected(project, searchProjectBuildingType, "projectBuildingType") &&
                        isDataSelected(project, searchHasFeatured, "hasFeatured")
                    );
                });
                setSearchedData(filteredResult);

                setPageCount( 
                    localStorage.getItem("pageCount") == null || localStorage.getItem("pageCount") == ''
                    ? Math.ceil(filteredResult.length / 21)
                    :parseInt(localStorage.getItem("pageCount")));

                setCurrentPageValue(
                    localStorage.getItem("pageValue") == null || localStorage.getItem("pageValue") == ''
                    ? 0
                    :parseInt(localStorage.getItem("pageValue")));
                setOffset(
                    localStorage.getItem("offset") == null || localStorage.getItem("offset") == ''
                    ? 21
                    :parseInt(localStorage.getItem("offset")));

                setItemOffset(
                    localStorage.getItem("ItemOffset") == null || localStorage.getItem("ItemOffset") == ''
                    ?0
                    :parseInt(localStorage.getItem("ItemOffset")));
            });
    }

    const handelPageClick = (event) => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        const newItemOffset = (event.selected * 21) % searchedData.length;
        const newOffset = (event.selected * 21) % searchedData.length + 21;
        setItemOffset(newItemOffset);
        setOffset(newOffset);
        setCurrentPageValue(event.selected);

        localStorage.setItem("pageCount", pageCount);
        localStorage.setItem("pageValue", event.selected);
        localStorage.setItem("offset", newOffset);
        localStorage.setItem("ItemOffset", newItemOffset);
    }

    return (
        <>
            <MainNavBar2 currentPage={"productList"}></MainNavBar2>
            <ProductListCategory2 setSearch={updateResult}></ProductListCategory2>
            {
                (loading === true)
                    ? <Loader></Loader>
                    : <></>
            }

            {
                (loading === false && currentItems.length === 0)
                    ? <section className="flex items-center h-full sm:p-16 dark:bg-gray-900 dark:text-gray-100">
                        <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8 space-y-8 text-center sm:max-w-md">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-40 h-40 dark:text-gray-600">
                                <path fill="currentColor" d="M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM403.078,403.078a207.253,207.253,0,1,1,44.589-66.125A207.332,207.332,0,0,1,403.078,403.078Z"></path>
                                <rect width="176" height="32" x="168" y="320" fill="currentColor"></rect>
                                <polygon fill="currentColor" points="210.63 228.042 186.588 206.671 207.958 182.63 184.042 161.37 162.671 185.412 138.63 164.042 117.37 187.958 141.412 209.329 120.042 233.37 143.958 254.63 165.329 230.588 189.37 251.958 210.63 228.042"></polygon>
                                <polygon fill="currentColor" points="383.958 182.63 360.042 161.37 338.671 185.412 314.63 164.042 293.37 187.958 317.412 209.329 296.042 233.37 319.958 254.63 341.329 230.588 365.37 251.958 386.63 228.042 362.588 206.671 383.958 182.63"></polygon>
                            </svg>
                            <p className="text-3xl">沒有找到相關案例</p>
                        </div>
                    </section>
                    :
                    <ProductList2 productListData={currentItems}></ProductList2>

            }

            {
                (pageLoading === true)
                    ? <></>
                    : <ReactPaginate
                        breakLabel="..."
                        nextLabel="下一頁 >"
                        onPageChange={handelPageClick}
                        pageRangeDisplayed={3}
                        pageCount={pageCount}
                        previousLabel="< 上一頁"
                        renderOnZeroPageCount={null}
                        containerClassName="border-t border-gray-200 px-4 flex items-center justify-between mt-14"
                        pageClassName="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium"
                        activeClassName="border-cyan-900 text-cyan-900 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium"
                        previousClassName="-mt-px w-0 flex-1 flex invisible"
                        nextClassName="-mt-px w-0 flex-1 flex justify-end invisible"
                        forcePage={currentPageValue}
                    />
            }
            <MainFloatingButton></MainFloatingButton>
            <MainFooter></MainFooter>
        </>
    );
}